import { useEffect, useRef } from 'react'

/**
 * useInterval Hook
 *
 * Custom hook that sets up an interval and cleans it up on unmount
 *
 * @param {Function} callback - Function to call on each interval
 * @param {number} delay - Delay in milliseconds (default: 1000)
 */
export const useInterval = (callback, delay = 1000) => {
  const savedCallback = useRef()

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    const tick = () => {
      savedCallback.current()
    }
    const id = setInterval(tick, delay)
    return () => clearInterval(id)
  }, [delay])
}
